import * as cf from './common';
import { BooleanMarkingsGraphSource, TemperatureGraphData } from './base';
import { LoadDataType } from '../load-types';
class OTTempGraphSource extends TemperatureGraphData {
    static _ot_field = null;
    data_source_key() {
        return LoadDataType.thermostat_work;
    }
    extract_data(raw_data) {
        if (OTTempGraphSource._ot_field == null) {
            console.error('OTTempGraphSource._ot_field is null');
            return null;
        }
        return raw_data?.ot?.[OTTempGraphSource._ot_field];
    }
}
export class OTGraphSource_CS extends OTTempGraphSource {
    static _ot_field = 'cs';
    class_name() {
        return 'OTGraphSource_CS';
    }
    title() {
        return 'расчётная t° ТН';
    }
    color() {
        if (this._color)
            return this._color;
        return '#cb4b4b';
    }
    extract_data(raw_data) {
        return raw_data?.ot?.[OTGraphSource_CS._ot_field];
    }
}
export class OTGraphSource_BT extends OTTempGraphSource {
    static _ot_field = 'bt';
    class_name() {
        return 'OTGraphSource_BT';
    }
    title() {
        return 't° ТН';
    }
    color() {
        if (this._color)
            return this._color;
        return '#cb8b8b';
    }
    extract_data(raw_data) {
        return raw_data?.ot?.[OTGraphSource_BT._ot_field];
    }
}
export class OTGraphSource_DS extends OTTempGraphSource {
    static _ot_field = 'ds';
    class_name() {
        return 'OTGraphSource_DS';
    }
    title() {
        return 'заданная t° ГВС';
    }
    color() {
        if (this._color)
            return this._color;
        return '#9440ed';
    }
    extract_data(raw_data) {
        return raw_data?.ot?.[OTGraphSource_DS._ot_field];
    }
}
export class OTGraphSource_DT extends OTTempGraphSource {
    static _ot_field = 'dt';
    class_name() {
        return 'OTGraphSource_DT';
    }
    title() {
        return 't° ГВС';
    }
    color() {
        if (this._color)
            return this._color;
        return '#4da74d';
    }
    extract_data(raw_data) {
        return raw_data?.ot?.[OTGraphSource_DT._ot_field];
    }
}
export class OTGraphSource_RWT extends OTTempGraphSource {
    static _ot_field = 'rwt';
    class_name() {
        return 'OTGraphSource_RWT';
    }
    title() {
        return 't° обратного потока';
    }
    color() {
        if (this._color)
            return this._color;
        return '#afd8f8';
    }
    extract_data(raw_data) {
        return raw_data?.ot?.[OTGraphSource_RWT._ot_field];
    }
}
export class OTGraphSource_OT extends OTTempGraphSource {
    static _ot_field = 'ot';
    class_name() {
        return 'OTGraphSource_OT';
    }
    title() {
        return 't° вне дома';
    }
    color() {
        if (this._color)
            return this._color;
        return '#edc240';
    }
    extract_data(raw_data) {
        return raw_data?.ot?.[OTGraphSource_OT._ot_field];
    }
}
export class OTGraphSource_RML extends OTTempGraphSource {
    static _ot_field = 'rml';
    class_name() {
        return 'OTGraphSource_RML';
    }
    title() {
        return 'уровень модуляции горелки';
    }
    color() {
        if (this._color)
            return this._color;
        return '#c42467';
    }
    yaxis_key() {
        return 'percent-0';
    }
    extract_data(raw_data) {
        return raw_data?.ot?.[OTGraphSource_RML._ot_field];
    }
}
export class OTGraphSource_WP extends OTTempGraphSource {
    static _ot_field = 'wp';
    class_name() {
        return 'OTGraphSource_WP';
    }
    title() {
        return 'давление теплоносителя';
    }
    color() {
        if (this._color)
            return this._color;
        return '#103ca0';
    }
    yaxis_key() {
        return 'pressure';
    }
    extract_data(raw_data) {
        return raw_data?.ot?.[OTGraphSource_WP._ot_field];
    }
}
export class OTGraphSource_FR extends OTTempGraphSource {
    static _ot_field = 'fr';
    class_name() {
        return 'OTGraphSource_FR';
    }
    title() {
        return 'скорость потока ГВС';
    }
    color() {
        if (this._color)
            return this._color;
        return '#a05e19';
    }
    yaxis_key() {
        return 'flow';
    }
    extract_data(raw_data) {
        return raw_data?.ot?.[OTGraphSource_FR._ot_field];
    }
}
class OTFlagGraphSource extends BooleanMarkingsGraphSource {
    static flag = null;
    data_source_key() {
        return LoadDataType.thermostat_work;
    }
    predicate(value) {
        return value?.includes(OTFlagGraphSource.flag);
    }
    extract_data(raw_data) {
        return raw_data?.ot?.s;
    }
    normalize_data(data) {
        return cf.normalize_time(data, 0);
    }
}
export class OTCHFlagGraphSource extends OTFlagGraphSource {
    static flag = 'ch';
    class_name() {
        return 'OTCHFlagGraphSource';
    }
    predicate(value) {
        return value?.includes(OTCHFlagGraphSource.flag);
    }
    title() {
        return 'Отопление активно';
    }
    color() {
        if (this._color) {
            return this._color;
        }
        return 'rgba(229, 200, 0, 0.4)';
    }
}
export class OTDHWFlagGraphSource extends OTFlagGraphSource {
    static flag = 'dhw';
    class_name() {
        return 'OTDHWFlagGraphSource';
    }
    title() {
        return 'ГВС активно';
    }
    predicate(value) {
        return value?.includes(OTDHWFlagGraphSource.flag);
    }
    color() {
        if (this._color)
            return this._color;
        return 'rgba(222, 0, 162, 0.4)';
    }
}
export const ot_line_graphs = [
    {
        field: 'cs',
        title: 'расчётная t° ТН',
        color: '#cb4b4b',
        yaxis_key: 'temperature',
    },
    {
        field: 'bt',
        title: 't° ТН',
        color: '#cb8b8b',
        yaxis_key: 'temperature',
    },
    // {
    //     field: 'ds'
    //     title: 'заданная t° ГВС'
    //     color: '#9440ed'
    //     yaxis_key: 'temperature'
    // }
    {
        field: 'dt',
        title: 't° ГВС',
        color: '#4da74d',
        yaxis_key: 'temperature',
    },
    {
        field: 'rwt',
        title: 't° обратного потока',
        color: '#afd8f8',
        yaxis_key: 'temperature',
    },
    {
        field: 'ot',
        title: 't° вне дома',
        color: '#edc240',
        yaxis_key: 'temperature',
    },
    {
        field: 'rml',
        title: 'уровень модуляции горелки',
        color: '#c42467',
        yaxis_key: 'percent-0',
    },
    {
        field: 'wp',
        title: 'давление теплоносителя',
        color: '#103ca0',
        yaxis_key: 'pressure',
    },
    {
        field: 'fr',
        title: 'скорость потока ГВС',
        color: '#a05e19',
        yaxis_key: 'flow',
    },
];
const ot_line_graphs_by_field = Object.fromEntries(ot_line_graphs.map((spec) => [spec.field, spec]));
export const ot_flag_graphs = [
    {
        flag: 'ch',
        title: 'Отопление активно',
        color: 'rgba(229, 200, 0, 0.4)',
    },
    {
        flag: 'dhw',
        title: 'ГВС активно',
        color: 'rgba(222, 0, 162, 0.4)',
    },
];
const ot_flag_graphs_by_flag = Object.fromEntries(ot_flag_graphs.map((spec) => [spec.flag, spec]));
export class OTZoneLineGraph extends TemperatureGraphData {
    class_name() {
        return 'OTZoneLineGraph';
    }
    zone_no;
    ot_field;
    _device_name;
    constructor(device, { zone_no, ot_field, color }) {
        // @ts-ignore
        // eslint-disable-next-line prefer-rest-params
        super(...arguments);
        this.zone_no = zone_no;
        this.ot_field = ot_field;
        this._color = color;
    }
    serialize_params() {
        return { zone_no: this.zone_no, ot_field: this.ot_field, color: this._color };
    }
    is_same(other) {
        if (this.constructor !== other.constructor)
            return false;
        if (this.zone_no !== other.zone_no)
            return false;
        if (this.ot_field !== other.ot_field)
            return false;
        return true;
    }
    title() {
        return this._device_name
            ? `${ot_line_graphs_by_field[this.ot_field].title} (${this._device_name})`
            : ot_line_graphs_by_field[this.ot_field].title;
    }
    color() {
        if (this._color)
            return this._color;
        return ot_line_graphs_by_field[this.ot_field].color;
    }
    yaxis_key() {
        return ot_line_graphs_by_field[this.ot_field].yaxis_key;
    }
    data_source_key() {
        return LoadDataType.otzones;
    }
    show_in_legend(data) {
        return data?.length > 0;
    }
    extract_data(raw_data) {
        return raw_data?.[this.zone_no]?.[this.ot_field];
    }
    normalize_data(data) {
        let prev_time = null;
        const result = [];
        for (const item of cf.time_mul_1k(cf.add_gaps(cf.normalize_time(data, 0), 6 * 60))) {
            if (item[0] === prev_time)
                continue;
            prev_time = item[0];
            result.push(item);
        }
        return result;
    }
    static all_for_zone(device, args) {
        return ot_line_graphs.map((spec) => new this(device, { ...args, ot_field: spec.field }));
    }
}
export class OTZoneFlagGraph extends BooleanMarkingsGraphSource {
    class_name() {
        return 'OTZoneFlagGraph';
    }
    zone_no;
    ot_flag;
    _device_name;
    constructor(device, { zone_no, ot_flag, color }) {
        // @ts-ignore
        // eslint-disable-next-line prefer-rest-params
        super(...arguments);
        this.zone_no = zone_no;
        this.ot_flag = ot_flag;
        this._color = color;
    }
    serialize_params() {
        return { zone_no: this.zone_no, ot_flag: this.ot_flag, color: this._color };
    }
    is_same(other) {
        if (this.constructor !== other.constructor)
            return false;
        if (this.zone_no !== other.zone_no)
            return false;
        if (this.ot_flag !== other.ot_flag)
            return false;
        return true;
    }
    title() {
        return this._device_name
            ? `${ot_flag_graphs_by_flag[this.ot_flag].title} (${this._device_name})`
            : ot_flag_graphs_by_flag[this.ot_flag].title;
    }
    color() {
        if (this._color)
            return this._color;
        return ot_flag_graphs_by_flag[this.ot_flag].color;
    }
    data_source_key() {
        return LoadDataType.otzones;
    }
    extract_data(raw_data) {
        return raw_data?.[this.zone_no]?.s;
    }
    normalize_data(data) {
        return cf.normalize_time(data, 0);
    }
    predicate(value) {
        return value?.includes(this.ot_flag);
    }
    static all_for_zone(device, args) {
        return ot_flag_graphs.map((spec) => new this(device, { ...args, ot_flag: spec.flag }));
    }
}
